import React, { FC, useState, useEffect, useRef } from 'react';
import DropdownItem from 'ui/CompanyAutocomplete/DropdownItem';
import { ICompany } from 'sections/Company/BlacklistPage/interfaces';
import useOnClickOutside from 'utils/hooks/useOnClickOutside';
import Preloader from 'ui/Preloader/Preloader';

interface ICompanyAutocomplete {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  dropdownItems: Array<ICompany>;
  customStyles?: any;
  value: string;
  error?: string;
  setFormData: (state: any) => void;
  setFormErrors: (state: any) => void;
  setSearchCompanyValue: (state: string) => void;
  // setSelectedCountry: (state: string) => void;
  readOnly: boolean;
  isCompaniesLoading: boolean;
}

const CompanyAutocomplete: FC<ICompanyAutocomplete> = ({
  id,
  name,
  label,
  placeholder,
  dropdownItems,
  customStyles,
  value,
  error,
  setFormData,
  setFormErrors,
  setSearchCompanyValue,
  // setSelectedCountry,
  readOnly,
  isCompaniesLoading,
}: ICompanyAutocomplete) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [isDropdownOpened, setIsDropdownOpened] = useState<boolean>(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  const openDropdownHandler = () => {
    setIsDropdownOpened(!isDropdownOpened);
  };

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
    setSearchCompanyValue(event.target.value);
  };

  const onDropdownClose = () => setIsDropdownOpened(false);

  // const onBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
  //     if (event.target.value === '') {
  //         setSelectedCountry('');
  //         setFormData((state: any) => {
  //             return {
  //                 ...state,
  //                 [name]: '',
  //                 country_code: '',
  //             }
  //         });
  //         return;
  //     }
  //
  //     setSelectedCountry(event.target.value);
  // };

  const renderDropdownElements = (sourceArray: Array<ICompany>) => {
    return sourceArray.map((item: ICompany, index: number) => {
      return (
        <DropdownItem
          key={`${item.id}_${index}`}
          item={item}
          name={name}
          setInputValue={setInputValue}
          setFormData={setFormData}
          setFormErrors={setFormErrors}
          onDropdownClose={onDropdownClose}
        />
      );
    });
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useOnClickOutside(dropdownRef, onDropdownClose);

  return (
    <div className="company-autocomplete" style={customStyles ? customStyles : {}} ref={dropdownRef}>
      <label className="company-autocomplete__label" htmlFor={id}>
        <span className="company-autocomplete__label-text">{label}</span>

        <input
          className={`company-autocomplete__input ${error ? 'error' : ''}`}
          type="text"
          readOnly={readOnly}
          id={id}
          name={name}
          placeholder={inputValue !== '' ? inputValue : placeholder}
          value={inputValue ?? ''}
          onChange={onChangeHandler}
          // onBlur={onBlurHandler}
          onClick={openDropdownHandler}
          role="presentation"
          autoComplete="off"
        />

        <img
          className={`company-autocomplete__input-icon ${isDropdownOpened ? 'is-opened' : ''}`}
          src="/images/pages/Resources/Blacklist/icon_arrow-down.svg"
          alt="dropdown-icon"
        />

        <ul className={`company-autocomplete__dropdown ${isDropdownOpened ? 'is-opened' : ''}`}>
          {isCompaniesLoading ? (
            <Preloader />
          ) : dropdownItems.length ? (
            renderDropdownElements(dropdownItems)
          ) : (
            <p className="company-autocomplete__notification">No results</p>
          )}
        </ul>
      </label>
      {error ? <p className="company-autocomplete__error">{error}</p> : <></>}
    </div>
  );
};

export default React.memo(CompanyAutocomplete);
